import { parse } from "graphql";
export const GET_USER_INBOX = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "getInbox"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "filter"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "InboxFilter"
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "getInbox"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "filter"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "filter"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "messageBodySize"
          },
          "value": {
            "kind": "IntValue",
            "value": "170"
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "messageId"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "inboxExpiry"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "expires"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "claimed"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "passed"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "new"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "reward"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "rewardFee"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "points"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "userId"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "groupName"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "tenantName"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "body"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "type"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "assignedExpertExpiry"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "tenantChannel"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 456,
    "source": {
      "body": "\n    query getInbox($filter: InboxFilter) {\n        getInbox(filter: $filter, messageBodySize: 170) {\n            messageId\n            inboxExpiry\n            expires\n            claimed\n            passed\n            new\n            reward\n            rewardFee\n            points\n            userId\n            groupName\n            tenantName\n            body\n            type\n            assignedExpertExpiry\n            tenantChannel\n        }\n    }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
const MESSAGE_BODY_SIZE = 150;
export const getTasksList = searchCriteria => {
  const types = "$filter: TaskFilter";
  const params = `filter:$filter,messageBodySize: ${MESSAGE_BODY_SIZE}`;
  const variables = {};
  const taskTypeFilter = [];
  const isGroupFilterApplied = [];
  const isFeeFilterApplied = [];
  const uniqueTenants = {};
  const TaskFilterReward = {};
  if (searchCriteria !== null && searchCriteria !== void 0 && searchCriteria.refreshCall) {
    var _Object$entries, _searchCriteria$newFi;
    (_Object$entries = Object.entries(searchCriteria === null || searchCriteria === void 0 ? void 0 : (_searchCriteria$newFi = searchCriteria.newFilters) === null || _searchCriteria$newFi === void 0 ? void 0 : _searchCriteria$newFi.selectedFilters)) === null || _Object$entries === void 0 ? void 0 : _Object$entries.map(([filterKey, value]) => {
      if (value.filtertType === "tasktype") {
        taskTypeFilter.push(value.filterValue);
      }
      if ("groupName" in value) {
        isGroupFilterApplied.push(value);
      }
      if (value.name === "Fee") {
        isFeeFilterApplied.push(value);
      }
    });
  } else {
    var _searchCriteria$newFi2;
    if ((searchCriteria === null || searchCriteria === void 0 ? void 0 : (_searchCriteria$newFi2 = searchCriteria.newFilters) === null || _searchCriteria$newFi2 === void 0 ? void 0 : _searchCriteria$newFi2.selectedFilters.length) > 0) {
      var _searchCriteria$newFi3, _searchCriteria$newFi5, _searchCriteria$newFi6;
      if (searchCriteria !== null && searchCriteria !== void 0 && (_searchCriteria$newFi3 = searchCriteria.newFilters) !== null && _searchCriteria$newFi3 !== void 0 && _searchCriteria$newFi3.taskType) {
        var _searchCriteria$newFi4;
        Object.entries(searchCriteria === null || searchCriteria === void 0 ? void 0 : (_searchCriteria$newFi4 = searchCriteria.newFilters) === null || _searchCriteria$newFi4 === void 0 ? void 0 : _searchCriteria$newFi4.taskType).map((key, value) => {
          if (key[1].value === true) {
            taskTypeFilter.push(key[1].filterValue);
          }
        });
      }
      if (((_searchCriteria$newFi5 = searchCriteria.newFilters) === null || _searchCriteria$newFi5 === void 0 ? void 0 : (_searchCriteria$newFi6 = _searchCriteria$newFi5.selectedGroups) === null || _searchCriteria$newFi6 === void 0 ? void 0 : _searchCriteria$newFi6.value.length) > 0) {
        searchCriteria.newFilters.selectedGroups.value.map(tenant => {
          uniqueTenants[tenant.tenantName] = [];
        });
        if (searchCriteria.newFilters.selectedGroups.value.length > 0) {
          searchCriteria.newFilters.selectedGroups.value.map(group => {
            uniqueTenants[group.tenantName].push(group.groupName);
          });
        }
      }
      if (searchCriteria.minMsgFee > 0) {
        TaskFilterReward.min = searchCriteria.minMsgFee;
      }
      if (searchCriteria.maxMsgFee > 0) {
        TaskFilterReward.max = searchCriteria.maxMsgFee;
      }
    }
  }
  if (taskTypeFilter.length > 0) {
    variables.taskType = taskTypeFilter;
  }
  if (isGroupFilterApplied.length > 0) {
    Object.entries(isGroupFilterApplied).map(([key, value]) => {
      uniqueTenants[value.tenantName] = [];
    });
    Object.entries(isGroupFilterApplied).map(([key, value]) => {
      uniqueTenants[value.tenantName].push(value.groupName);
    });
  }
  if (searchCriteria.fetchPass) {
    variables.passed = true;
  }
  const tenantGroups = [];
  Object.keys(uniqueTenants).map(tenantName => {
    const tenantGroup = {
      tenantName
    };
    const groupsForTenant = uniqueTenants[tenantName];
    //in case we only select a tenant
    if (groupsForTenant && groupsForTenant.length !== 0) {
      tenantGroup.groupNames = groupsForTenant;
    }
    tenantGroups.push(tenantGroup);
  });
  if (tenantGroups.length > 0) {
    variables.tenantGroups = tenantGroups;
  }
  if ((isFeeFilterApplied === null || isFeeFilterApplied === void 0 ? void 0 : isFeeFilterApplied.length) !== 0) {
    if (searchCriteria.minMsgFee > 0) {
      TaskFilterReward.min = searchCriteria.minMsgFee;
    }
    if (searchCriteria.maxMsgFee > 0) {
      TaskFilterReward.max = searchCriteria.maxMsgFee;
    }
  }
  if (Object.keys(TaskFilterReward).length > 0) {
    variables.reward = TaskFilterReward;
  }
  const query = parse(`
        query getTasks(${types}) {
            getTasks(${params}) {
                tasks {
                    claimedAt
                    expires
                    reported
                    reward
                    rewardFee
                    claimed
                    reviewed
                    escalated
                    messageId
                    userId
                    userName
                    claimTimeout
                    body
                    author
                    passed
                    responded
                    claimTimeoutInc
                    groupName
                    created
                    tenantName
                    updated
                    new
                    type
                    totalIncrement
                    deleted
                    assignedExpertExpiry
                    expertCountry
                    msgAvailabilityGroup
                    msgAvailabilityReleased
                    msgAvailableFrom
                    deployed
                    claimExtendUIControl
                    tenantChannel
                    inboxExpiry
                    messageFeeReview
                    displayName
                    points
                }
                  count
                  total
            
        }
    }
 `);
  return {
    query,
    variables
  };
};